import styled from 'styled-components';
import {FlexCentered, PrimaryLink} from '../../../CommonStyleUtils/dwebCommon.styles';
import Image from '@stencil/image';

export const GoSafeSearchBlockContainerWrap = styled(FlexCentered)(
  props => `
    border-radius: ${props.theme.misc.borderRadius.xxlarge};
    padding: ${props.theme.spacing.base};
    background: ${props.backgroundColor || props.theme.colors.goWhite.base};
    `,
);

export const GoSafeCardHeader = styled.p(
  props => `
  color: ${props.color || props.theme.colors.downriver.base};
  `,
);

export const GoSafeSearchBlockTextWrap = styled.div(
  props => `
    font-size: ${props.theme.font.custom(16)};
    margin-left: ${props.theme.spacing.base};
    `,
);

export const GlobeAlertIconWrap = styled(Image)(
  props => `
  width:3.4rem;
  height:3.2rem;
  `,
);

export const GoSafeLearnMoreBtn = styled(PrimaryLink)(
  props => `
    color: ${props.color || props.theme.colors.goBrandBlue.base};
    margin-left: ${props.theme.spacing.small};
    `,
);

export const GoSafeCasesInfoText = styled.p(
  props => `
    color: ${props.color || props.theme.colors.goGreen.base};
    font-size: ${props.theme.font.custom(14)};
    margin-top: ${props.theme.spacing.small};
    `,
);

export const GosafeEarthSaverImg = styled(Image)(
  props => `
  width: 3rem;
  height: 3rem;
  object-fit: contain;
    `,
);
